import { ShieldCheck, Clock, Users } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const REASONS = [
  { icon: ShieldCheck, title: "Farms trust us with their doors", text: "Our partners only meet buyers we've personally screened, ID-verified and interviewed." },
  { icon: Clock, title: "Nobody's time gets wasted", text: "Serious buyers meet serious growers. No tire-kickers, no window shoppers." },
  { icon: Users, title: "A network, not a marketplace", text: "No listings, no bidding wars. Just curated, in-person relationships that last." },
];

export const WhyWeVet = () => (
  <section id="why-we-vet" className="py-24 sm:py-32 bg-secondary/50" data-testid="why-we-vet-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid gap-12 lg:grid-cols-12 items-center">
      <Reveal className="lg:col-span-5 relative">
        <div className="absolute -inset-3 rounded-[2rem] bg-gradient-to-br from-amber-400 via-purple-500 to-emerald-500 opacity-70 blur-xl" />
        <img src="/images/why-we-vet.jpg" alt="I'm The Plug Now - 100% of buyers interviewed" className="relative rounded-[2rem] w-full h-auto max-w-md mx-auto" data-testid="why-we-vet-image" />
      </Reveal>
      <div className="lg:col-span-7 lg:pl-8">
        <Reveal>
          <p className="eyebrow text-purple-500">Why we vet</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-bold tracking-tight">Protecting our farms is priority number one.</h2>
          <p className="mt-5 text-muted-foreground text-base sm:text-lg leading-relaxed max-w-xl">
            Every buyer is screened, ID-verified and interviewed before approval. It's a little extra effort up front, and it's exactly why our farm partners pick up when we call.
          </p>
        </Reveal>
        <div className="mt-10 space-y-4">
          {REASONS.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.1}>
              <div className="flex gap-4 rounded-2xl bg-card border border-border p-5 hover:border-primary/60 transition-colors">
                <div className="h-11 w-11 shrink-0 rounded-xl bg-primary/15 grid place-items-center"><r.icon className="h-5 w-5 text-primary" /></div>
                <div>
                  <h3 className="font-bold text-lg">{r.title}</h3>
                  <p className="text-muted-foreground">{r.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
